import React from "react";
import { motion } from 'framer-motion';
import SupportImage from '../../assets/images/support.svg';
import SeparatorImage from '../../assets/images/separator.svg';
import DonationButton from "./DonateButton";

export default function SupportSection({ id }) {
    const titleClass = 'font-bold lg:text-xl text-left text-md'
    const textClass = 'lg:text-xl pb-2 text-md text-left'
    return (
        <motion.div id={id} className="bg-white flex justify-center w-full mx-auto scroll-mt-16">
            <div className="flex flex-col lg:flex-row lg:h-dvh space-y-6 lg:space-y-0 lg:space-x-9 items-center lg:p-20 p-10">

                {/* Imagen de apoyo */}
                <motion.img
                    initial={{ y: 20, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 1, ease: "easeOut" }}
                    viewport={{ once: true }}
                    src={SupportImage}
                    alt="Apoyar"
                    className="w-10/12 lg:w-5/12 mx-auto"
                />

                {/* Separador: vertical en desktop, horizontal en mobile */}
                <img
                    src={SeparatorImage}
                    alt="Separador"
                    className="w-[1.5px] hidden lg:h-[500px] lg:flex lg:w-auto  mx-auto rotate-90 lg:rotate-0"
                />
                <div className="lg:hidden w-full mx-auto border-t border-dashed border-black my-6"></div>

                {/* Texto y botón */}
                <motion.div
                    initial={{ y: 20, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    viewport={{ once: true, amount: 0.7 }}
                    className="font-lato flex flex-col lg:space-y-4 text-center lg:text-left space-y-1">
                    <p className={titleClass}>Donativos en especie.</p>
                    <p className={textClass}>Recibimos insumos alimenticios y de higiene personal para nuestras jornadas callejeras: café, azúcar, pan dulce, cajas de té, vasos, cucharas desechables, cepillos de dientes y toallas sanitarias.</p>
                    <p className={titleClass}>Donativos monetarios.</p>
                    <p className={textClass}>Puedes dejarnos un donativo en tu próxima visita a nuestro Centro de Atención o realizarla a través de esta página.</p>
                    <p className={titleClass}>Compra en Solidaria Bazar.</p>
                    <p className={textClass}>Nuestro bazar cuenta con artículos nuevos a bajo precio y todas las compras van directamente a apoyar nuestros proyectos. ¡Síguelo en Instagram @solidariabazar!</p>
                    <div className="flex justify-center lg:justify-start">
                        <DonationButton />
                    </div>
                </motion.div>
            </div>
        </motion.div>
    );
}

